export default function ScansOverview(props) {
  const { title, value, imageSrc } = props;
  return (
    <>
      <div className="flex flex-column">
        <label className="text-xxl flex">
          <img src={imageSrc} alt={title} style={{ width: '20px' }} /> {value}
        </label>
        <label className="text-xl">{title}</label>
      </div>
    </>
  );
}
